import ClickAndCollect from "@lib/constants/contentful/clickAndCollect";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { Button } from "@ecco/ui/button";
import { Circle } from "@ecco/ui/circle";
import { Flex } from "@ecco/ui/flex";
import type { StoreData } from "@features/stores/types";
import { useStore } from "@store/store";
import type { ProductVariant } from "@lib/product/types";
import { Logger, LogTag, ServiceType } from "@lib/monitoring/logger";

type Props = {
    store?: StoreData;
    onClose?: () => void;
    selectedVariant?: ProductVariant;
};

export const AvailabilityComponent = ({ store, onClose, selectedVariant }: Props) => {
    const setStoreData = useStore((state) => state.setStoreData);
    const { getMultiple } = useMicrocopy();

    // Only set the store. SupplyChannel will be added to basket in the add-to-cart API calls.
    const handleSetStore = () => {
        Logger.info(ServiceType.WEB, "Selected pickup store", {
            tag: LogTag.SHIPPING,
            storeId: store?.storeId,
            supplyChannelId: store?.supplyChannel?.[0]?.id,
        });
        setStoreData(store);
        onClose();
    };

    const microcopies = (() => {
        return getMultiple("page", [
            ClickAndCollect.availableSoon,
            ClickAndCollect.available,
            ClickAndCollect.selectStore,
            ClickAndCollect.changeStore,
        ]);
    })();

    const foundStore = selectedVariant.availability.some((supplyChannels) => {
        return supplyChannels.id === store?.supplyChannel?.[0].id && supplyChannels.isOnStock;
    });

    const availabilityColor = foundStore ? "green.200" : "yellow.200";
    const availabilityText = foundStore
        ? microcopies[ClickAndCollect.available]
        : microcopies[ClickAndCollect.availableSoon];
    return (
        <Flex
            justifyContent={"space-between"}
            color="black"
            fontWeight="bold"
            flexDirection={["column", "column", "row"]}
            gap={4}
        >
            <Flex gap={2} fontSize={"mobileBodyTextSmall"} alignItems={"center"}>
                <Circle size={2} bg={availabilityColor} />
                {availabilityText}
            </Flex>
            <Button
                type="button"
                zIndex={10}
                h={10}
                w={["100%", "100%", "auto"]}
                fontSize={"mobileBodyTextNormal"}
                onClick={handleSetStore}
            >
                <span>{microcopies[ClickAndCollect.selectStore]}</span>
            </Button>
        </Flex>
    );
};
